export const actions = {
  REQUEST_QUIZ_DATA: "REQUEST_QUIZ_DATA",
  UPDATE_FLAG: "UPDATE_FLAG",
  UPDATE_ANSWER: "UPDATE_ANSWER",
  UPDATE_ATTEMPTS: "UPATE_ATTEMPTS",
  SAVE_QUIZ_DATA: "SAVE_QUIZ_DATA",
  UPDATE_START: "UPDATE_START",
  UPDATE_QUIZ_PROGRESS: "UPDATE_QUIZ_PROGRESS",
  TOGGLE_LOADING: "TOGGLE_LOADING",
  UPDATE_RESUME: "UPDATE_RESUME",
};

export interface IAction {
  type: string;
  payload?: any;
}

export interface IQuizRequestParams {
  id: string;
  type: string;
}

export interface IQuizProgressParams {
  quizID: string;
  userID: string;
  progress: any;
  correctAnswer?: any;
}

export interface IQuizRequestProgressParams {
  quizID: string;
  userID: string;
}
